<template>
    <div class="proxy-page full-height">
        <el-row :gutter="12" class="full-height-row">
            <!-- 左侧：生效代理池（运行时代理） -->
            <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11" class="column-box">
                <el-card class="box-card full-card" :body-style="{ padding: '12px', display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box' }">
                    <div slot="header" class="card-header-row">
                        <div class="card-header-title">
                            <i class="el-icon-connection" style="color: #409eff; margin-right: 6px;" />
                            <span>生效代理池（已配置代理）</span>
                        </div>
                        <div class="card-header-extra">
                            共 {{ respModel.totalCount || 0 }} 条代理链接
                        </div>
                    </div>

                    <!-- 搜索与操作栏 -->
                    <div class="left-top-bar">
                        <el-form ref="queryForm" :inline="true" :model="queryFormModel" size="small" class="query-form">
                            <el-form-item label="区域">
                                <el-input
                                    v-model="queryFormModel.area"
                                    placeholder="按区域筛选"
                                    clearable
                                    style="width: 140px;"
                                    @keyup.enter.native="fetchTableData"
                                />
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="small" icon="el-icon-search" @click="fetchTableData">查询</el-button>
                                <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
                            </el-form-item>
                        </el-form>

                        <div class="left-action-buttons">
                            <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddNew">新增</el-button>
                            <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="fetchTableData">刷新</el-button>
                            <el-button
                                type="danger"
                                size="small"
                                icon="el-icon-delete"
                                :disabled="!leftSelectedRows.length"
                                @click="handleDelete"
                            >删除</el-button>
                        </div>
                    </div>

                    <!-- 表格 -->
                    <div class="table-container">
                        <vxe-table
                            ref="xProxyTable"
                            :data="respModel.list"
                            size="mini"
                            highlight-current-row
                            :loading="loading"
                            stripe
                            border
                            show-overflow
                            align="center"
                            :row-config="{ keyField: '_id' }"
                            @cell-dblclick="handleCellDbClick"
                            @checkbox-change="onProxySelectionChange"
                            @checkbox-all="onProxySelectionChange"
                            @sort-change="handleSortChange"
                            :sort-config="{ trigger: 'cell', defaultSort: { field: 'createdTime', order: 'desc' }, remote: true }"
                            :empty-render="{ name: 'EmptyData' }"
                            resizable
                            height="auto"
                            :checkbox-config="{ trigger: 'row' }"
                        >
                            <vxe-table-column type="checkbox" width="45" fixed="left" />
                            <vxe-table-column type="seq" width="45" fixed="left" />
                            <vxe-table-column field="area" title="区域" width="85" />
                            <vxe-table-column field="url" title="提取链接" min-width="190" align="left" />
                            <vxe-table-column title="操作" width="120" fixed="right" :show-overflow="false">
                                <template #default="{ row }">
                                    <el-button type="text" size="mini" icon="el-icon-edit" @click="handleEditRow(row)">编辑</el-button>
                                    <el-button type="text" size="mini" icon="el-icon-delete" class="danger-link" @click="handleDeleteRow(row)">删除</el-button>
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                    </div>

                    <!-- 分页 -->
                    <div class="pager-container">
                        <vxe-pager
                            perfect
                            align="center"
                            size="mini"
                            :current-page.sync="respModel.currentPage"
                            :page-size.sync="respModel.pageSize"
                            :total="respModel.totalCount"
                            @page-change="handlePageChange"
                            :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                        />
                    </div>
                </el-card>
            </el-col>

            <!-- 右侧：代理源管理与提取链接生成器 -->
            <el-col :xs="24" :sm="24" :md="13" :lg="13" :xl="13" class="column-box right-box">
                <!-- 右侧上部卡片：提取链接生成 -->
                <el-card class="box-card right-generator-card" :body-style="{ padding: '12px' }">
                    <div slot="header" class="card-header-row">
                        <div class="card-header-title">
                            <i class="el-icon-magic-stick" style="color: #67c23a; margin-right: 6px;" />
                            <span>提取链接生成</span>
                        </div>
                        <div v-if="selectedSource" class="card-header-extra">
                            <span>当前源：</span>
                            <el-tag size="mini" type="info">{{ selectedSource.name }}</el-tag>
                            <span class="provider-sub-text">
                                ({{ providerLabel(selectedSource.provider) }})
                            </span>
                        </div>
                    </div>

                    <el-form :inline="true" :model="generateForm" size="small" class="generator-inline-form">
                        <el-form-item label="代理源">
                            <div class="source-select-wrap">
                                <el-select
                                    v-model="generateForm.sourceId"
                                    placeholder="请选择代理源"
                                    style="width: 170px"
                                    @change="handleSourceChange"
                                >
                                    <el-option
                                        v-for="source in enabledSources"
                                        :key="source._id"
                                        :label="source.name"
                                        :value="source._id"
                                    >
                                        <span>{{ source.name }}</span>
                                        <span class="option-provider-text">{{ providerLabel(source.provider) }}</span>
                                    </el-option>
                                </el-select>

                                <!-- 当前选中代理源套餐余量 -->
                                <span v-if="selectedSource" class="selected-balance-inline">
                                    <span v-if="balanceLoadingMap[selectedSource._id]" class="balance-loading">
                                        <i class="el-icon-loading" />
                                    </span>
                                    <template v-else-if="balanceMap[selectedSource._id]">
                                        <el-tag
                                            v-if="balanceMap[selectedSource._id].success"
                                            size="mini"
                                            :type="getBalanceTagType(balanceMap[selectedSource._id])"
                                            effect="plain"
                                        >
                                            {{ balanceMap[selectedSource._id].text }}
                                        </el-tag>
                                        <el-tooltip
                                            v-else
                                            :content="balanceMap[selectedSource._id].message || '余量查询失败'"
                                            placement="top"
                                        >
                                            <el-tag size="mini" type="info" class="balance-tag-clickable">
                                                余量异常
                                            </el-tag>
                                        </el-tooltip>
                                        <i
                                            class="el-icon-refresh balance-refresh-icon"
                                            title="刷新此代理源余量"
                                            @click="refreshSingleBalance(selectedSource._id)"
                                        />
                                    </template>
                                    <template v-else>
                                        <el-button
                                            type="text"
                                            size="mini"
                                            icon="el-icon-view"
                                            @click="refreshSingleBalance(selectedSource._id)"
                                        >查余量</el-button>
                                    </template>
                                </span>
                            </div>
                        </el-form-item>

                        <el-form-item label="地区">
                            <el-select
                                v-model="generateForm.area"
                                filterable
                                clearable
                                :disabled="selectedProvider === 'duomi'"
                                style="width: 130px"
                                :placeholder="selectedProvider === 'duomi' ? '仅支持全国' : '全国 (默认)'"
                            >
                                <el-option
                                    v-for="region in regions"
                                    :key="region.value"
                                    :label="region.label"
                                    :value="region.value"
                                />
                            </el-select>
                        </el-form-item>

                        <el-form-item label="数量">
                            <el-input-number
                                v-model="generateForm.num"
                                :min="1"
                                :max="100"
                                controls-position="right"
                                style="width: 85px"
                            />
                        </el-form-item>

                        <el-form-item>
                            <el-button
                                type="primary"
                                icon="el-icon-magic-stick"
                                size="small"
                                :loading="generating"
                                :disabled="!generateForm.sourceId"
                                @click="generateLink"
                            >生成链接</el-button>
                            <el-button size="small" @click="resetGenerateForm">重置</el-button>
                        </el-form-item>
                    </el-form>

                    <!-- 暂无可用代理源提示 -->
                    <div v-if="!enabledSources.length" class="empty-source-tip">
                        <i class="el-icon-warning-outline" />
                        <span>暂无可用代理源，请先在下方点击「新增代理源」完成配置</span>
                    </div>

                    <!-- 生成结果展示条 -->
                    <div v-if="generatedLink" class="result-action-bar">
                        <el-input
                            v-model="generatedLink"
                            readonly
                            size="small"
                            class="result-url-input"
                        >
                            <template slot="prepend">提取链接</template>
                        </el-input>
                        <el-button
                            type="success"
                            size="small"
                            icon="el-icon-download"
                            :loading="savingToProxy"
                            @click="handleSaveToProxyPool"
                        >存入代理池</el-button>
                        <el-button type="primary" size="small" icon="el-icon-document-copy" @click="copyLink">复制</el-button>
                        <el-button size="small" icon="el-icon-top-right" @click="openLinkInNewTab">打开</el-button>
                        <el-button
                            type="warning"
                            size="small"
                            icon="el-icon-video-play"
                            :loading="testingFetch"
                            @click="testExtractFetch"
                        >测试提取</el-button>
                        <el-button size="small" icon="el-icon-close" @click="clearGenerated">清空</el-button>
                    </div>

                    <!-- 测试提取结果即时反馈 -->
                    <div v-if="fetchResult" class="test-feedback-box" :class="fetchResult.success ? 'is-success' : 'is-fail'">
                        <div class="feedback-header">
                            <div>
                                <i :class="fetchResult.success ? 'el-icon-circle-check' : 'el-icon-circle-close'" />
                                <strong style="margin-left: 4px;">{{ fetchResult.success ? '接口调用成功' : '提取失败' }}：</strong>
                                <span>{{ fetchResult.message }}</span>
                            </div>
                            <el-button type="text" size="mini" @click="fetchResult = null">关闭</el-button>
                        </div>
                        <div v-if="fetchResult.proxies && fetchResult.proxies.length" class="proxies-row">
                            <span class="proxies-tag-title">返回 IP：</span>
                            <el-tag
                                v-for="(ip, idx) in fetchResult.proxies"
                                :key="idx"
                                size="mini"
                                type="success"
                                class="proxy-tag"
                                @click="copyText(ip, '代理 IP 已复制')"
                            >
                                {{ ip }} <i class="el-icon-document-copy" />
                            </el-tag>
                        </div>
                    </div>
                </el-card>

                <div style="height: 10px;" />

                <!-- 右侧下部卡片：代理源列表管理 -->
                <el-card class="box-card right-sources-card" :body-style="{ padding: '12px', display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box' }">
                    <div slot="header" class="card-header-row">
                        <div class="card-header-title">
                            <i class="el-icon-s-operation" style="color: #e6a23c; margin-right: 6px;" />
                            <span>代理源配置（平台账号）</span>
                        </div>
                        <div class="card-header-extra">
                            共 {{ sources.length }} 个源，{{ enabledSources.length }} 个启用
                        </div>
                    </div>

                    <!-- 顶部操作栏 -->
                    <div class="table-toolbar-row">
                        <div class="toolbar-left">
                            <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreateSource">新增代理源</el-button>
                            <el-button size="small" icon="el-icon-refresh" :loading="loadingSources" @click="loadSources">刷新</el-button>
                            <el-button size="small" icon="el-icon-coin" :loading="loadingBalances" @click="loadAllBalances">查余量</el-button>
                            <el-button
                                type="danger"
                                size="small"
                                icon="el-icon-delete"
                                :disabled="!selectedSources.length"
                                @click="deleteSelectedSources"
                            >删除</el-button>
                        </div>
                        <div class="toolbar-right">
                            <el-input
                                v-model="searchKeyword"
                                placeholder="搜索名称 / 账号 / 单号"
                                prefix-icon="el-icon-search"
                                size="small"
                                clearable
                                style="width: 170px;"
                            />
                        </div>
                    </div>

                    <!-- 数据表格 -->
                    <div class="sources-table-container">
                        <vxe-table
                            ref="xSourceTable"
                            :data="filteredSources"
                            size="mini"
                            highlight-current-row
                            :loading="loadingSources"
                            stripe
                            border
                            show-overflow
                            align="center"
                            :row-config="{ keyField: '_id' }"
                            :checkbox-config="{ trigger: 'row' }"
                            :sort-config="{ trigger: 'cell', defaultSort: { field: 'sortOrder', order: 'asc' } }"
                            resizable
                            height="auto"
                            @checkbox-change="updateSelectedSources"
                            @checkbox-all="updateSelectedSources"
                            @cell-dblclick="handleSourceCellDbClick"
                        >
                            <vxe-table-column type="checkbox" width="45" fixed="left" />
                            <vxe-table-column type="seq" width="45" fixed="left" />
                            <vxe-table-column field="sortOrder" title="排序" width="65" sortable align="center">
                                <template #default="{ row }">
                                    <span>{{ row.sortOrder != null ? row.sortOrder : 0 }}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="name" title="代理源名称" min-width="120" align="left" />
                            <vxe-table-column field="provider" title="平台" width="95">
                                <template #default="{ row }">
                                    <el-tag size="mini" :type="row.provider === 'juliang' ? 'warning' : (row.provider === 'duomi' ? 'success' : 'primary')">
                                        {{ providerLabel(row.provider) }}
                                    </el-tag>
                                    <span
                                        v-if="row.provider === 'ipzan' && row.providerConfig && row.providerConfig.packageType === 'quantity'"
                                        class="edition-mini-badge"
                                    >
                                        按量
                                    </span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column title="单号 / Key" min-width="140" align="left">
                                <template #default="{ row }">
                                    <span v-if="row.provider === 'duomi'">
                                        key: {{ row.credentials ? (row.credentials.apiKey || '-') : '-' }}
                                    </span>
                                    <span v-else-if="row.credentials && row.credentials.tradeNo">
                                        {{ row.provider === 'ipzan' ? 'no' : 'trade_no' }}: {{ row.credentials.tradeNo }}
                                    </span>
                                    <span v-else>-</span>
                                    <span v-if="row.credentials && row.credentials.account" class="text-muted" style="margin-left: 4px;">
                                        ({{ row.credentials.account }})
                                    </span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column title="套餐余量" min-width="130" align="center" :show-overflow="false">
                                <template #default="{ row }">
                                    <div class="balance-cell">
                                        <span v-if="balanceLoadingMap[row._id]" class="balance-loading">
                                            <i class="el-icon-loading" /> 查询中
                                        </span>
                                        <template v-else-if="balanceMap[row._id]">
                                            <el-tag
                                                v-if="balanceMap[row._id].success"
                                                size="mini"
                                                :type="getBalanceTagType(balanceMap[row._id])"
                                            >
                                                {{ balanceMap[row._id].text }}
                                            </el-tag>
                                            <el-tooltip
                                                v-else
                                                :content="balanceMap[row._id].message || '查询失败'"
                                                placement="top"
                                            >
                                                <el-tag size="mini" type="info" class="balance-tag-clickable">
                                                    {{ balanceMap[row._id].message || '查询失败' }}
                                                </el-tag>
                                            </el-tooltip>
                                            <i
                                                class="el-icon-refresh balance-refresh-icon"
                                                title="刷新此项余量"
                                                @click.stop="refreshSingleBalance(row._id)"
                                            />
                                        </template>
                                        <template v-else>
                                            <el-button
                                                type="text"
                                                size="mini"
                                                icon="el-icon-view"
                                                @click.stop="refreshSingleBalance(row._id)"
                                            >查询</el-button>
                                        </template>
                                    </div>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="enabled" title="状态" width="70">
                                <template #default="{ row }">
                                    <el-switch
                                        v-model="row.enabled"
                                        :active-value="true"
                                        :inactive-value="false"
                                        active-color="#13ce66"
                                        @change="toggleSourceStatus(row)"
                                    />
                                </template>
                            </vxe-table-column>
                            <vxe-table-column title="操作" width="105" fixed="right" :show-overflow="false">
                                <template #default="{ row }">
                                    <el-button
                                        type="text"
                                        size="mini"
                                        icon="el-icon-edit"
                                        @click="openEditSource(row)"
                                    >编辑</el-button>
                                    <el-button
                                        type="text"
                                        size="mini"
                                        icon="el-icon-delete"
                                        class="danger-link"
                                        @click="deleteSource(row)"
                                    >删除</el-button>
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 左侧编辑代理弹窗 -->
        <el-dialog
            :title="formModel && formModel._id ? '编辑代理' : '新增代理'"
            :visible.sync="formDialogVisible"
            :close-on-click-modal="false"
            top="20vh"
            width="550px"
        >
            <proxy-form
                v-if="formDialogVisible"
                :prop-form-model="formModel"
                @close="formDialogVisible = false"
                @refresh="fetchTableData"
            />
        </el-dialog>

        <!-- 右侧新增/编辑代理源弹窗 -->
        <el-dialog
            :title="sourceFormModel ? (sourceFormModel._id ? '编辑代理源' : '新增代理源') : '新增代理源'"
            :visible.sync="sourceDialogVisible"
            width="800px"
            :close-on-click-modal="false"
        >
            <source-form
                v-if="sourceDialogVisible"
                :prop-form-model="sourceFormModel"
                @refresh="handleSourceSaved"
                @close="sourceDialogVisible = false"
            />
        </el-dialog>
    </div>
</template>

<script>
import ProxyForm from '@/views/order/proxy/form.vue'
import SourceForm from '@/views/order/proxySource/components/SourceForm.vue'
import proxyService from '@/api/order/ProxyService'
import proxySourceService from '@/api/order/ProxySourceService'
import { mapState } from 'vuex'

const DEFAULT_GENERATE_FORM = {
    sourceId: '',
    area: '',
    num: 1,
    protocol: 'http',
    resultType: 'text',
    split: 1,
    filter: 1,
    autoWhite: 1
}

export default {
    name: 'ProxyManagementIndex',
    components: {
        ProxyForm,
        SourceForm
    },
    data() {
        return {
            // === 左侧：生效代理池状态 ===
            loading: false,
            leftSelectedRows: [],
            queryFormModel: {
                currentPage: 1,
                pageSize: 15,
                area: ''
            },
            respModel: {
                currentPage: 1,
                pageSize: 15,
                totalCount: 0,
                list: []
            },
            formDialogVisible: false,
            formModel: null,

            // === 右侧：代理源与提取状态 ===
            sources: [],
            providers: [],
            regions: [],
            loadingSources: false,
            loadingBalances: false,
            selectedSources: [],
            searchKeyword: '',
            balanceMap: {},
            balanceLoadingMap: {},

            // 链接生成器
            generateForm: { ...DEFAULT_GENERATE_FORM },
            generating: false,
            generatedLink: '',
            generatedSummary: null,
            testingFetch: false,
            fetchResult: null,

            // 代理源弹窗
            sourceDialogVisible: false,
            sourceFormModel: null,

            // 存入代理池状态
            savingToProxy: false
        }
    },
    computed: {
        ...mapState(['isLoggedIn', 'user']),
        enabledSources() {
            return this.sources.filter(source => source.enabled !== false)
        },
        selectedSource() {
            return this.sources.find(source => source._id === this.generateForm.sourceId) || null
        },
        selectedProvider() {
            return this.selectedSource?.provider || ''
        },
        filteredSources() {
            if (!this.searchKeyword) return this.sources
            const kw = this.searchKeyword.toLowerCase().trim()
            return this.sources.filter(item => {
                const name = (item.name || '').toLowerCase()
                const account = (item.credentials?.account || '').toLowerCase()
                const tradeNo = (item.credentials?.tradeNo || '').toLowerCase()
                return name.includes(kw) || account.includes(kw) || tradeNo.includes(kw)
            })
        }
    },
    watch: {
        'user.tenantCode'() {
            this.fetchTableData()
            this.loadSources()
        },
        enabledSources: {
            immediate: true,
            handler(list) {
                if (!this.generateForm.sourceId && list && list.length) {
                    this.generateForm.sourceId = list[0]._id
                    this.handleSourceChange(list[0]._id)
                }
            }
        }
    },
    methods: {
        // ==========================================
        // ========== 左侧：生效代理池方法 ==========
        // ==========================================
        buildQuery() {
            const query = {}
            const { area } = this.queryFormModel
            if (this.$strings.isNotBlank(area)) {
                query.area = area
            }

            const tenantCode = this.user?.tenantCode || (this.$isSuperAdmin(this.user) ? 'admin' : '')
            if (this.$strings.isNotBlank(tenantCode)) {
                query.tenantCode = tenantCode
            }

            return query
        },
        buildSort() {
            return {
                createdTime: -1
            }
        },
        fetchTableData() {
            this.loading = true
            const query = this.buildQuery()
            const sortOptions = this.buildSort()
            const { currentPage, pageSize } = this.queryFormModel

            proxyService.page(currentPage, pageSize, query, sortOptions)
                .then(res => {
                    this.respModel = res.data || {
                        currentPage: 1,
                        pageSize: 15,
                        totalCount: 0,
                        list: []
                    }
                }).finally(() => {
                    this.loading = false
                })
        },
        onProxySelectionChange() {
            this.leftSelectedRows = this.$refs.xProxyTable.getCheckboxRecords() || []
        },
        handleCellDbClick({ row, column }) {
            const { title, type } = column
            if (title === '操作' || type === 'checkbox') {
                return
            }
            this.handleEditRow(row)
        },
        handleAddNew() {
            this.formModel = {
                area: '',
                url: '',
                remark: ''
            }
            this.formDialogVisible = true
        },
        handleEditRow(row) {
            this.formModel = JSON.parse(JSON.stringify(row))
            this.formDialogVisible = true
        },
        handleDeleteRow(row) {
            this.$confirm(`确定删除区域为“${row.area || '全国'}”的代理吗？`, '删除提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                return proxyService.deleteById(row._id)
            }).then(() => {
                this.$message.success('删除成功')
                this.fetchTableData()
            }).catch(() => {})
        },
        handleDelete() {
            const checkedRows = this.$refs.xProxyTable.getCheckboxRecords() || []
            if (checkedRows.length === 0) return

            this.$confirm(`确定删除选中的 ${checkedRows.length} 个代理吗？`, '批量删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const ids = checkedRows.map(o => o._id)
                return proxyService.deleteByIds(ids)
            }).then(res => {
                this.$message.success(res.message || '删除成功')
                this.leftSelectedRows = []
                this.fetchTableData()
            }).catch(() => {})
        },
        handleReset() {
            this.queryFormModel = {
                currentPage: 1,
                pageSize: 15,
                area: ''
            }
            this.fetchTableData()
        },
        handlePageChange({ currentPage, pageSize }) {
            this.queryFormModel.currentPage = currentPage
            this.queryFormModel.pageSize = pageSize
            this.fetchTableData()
        },
        handleSortChange({ property, order }) {
            this.queryFormModel.sidx = property
            this.queryFormModel.order = order
            this.fetchTableData()
        },

        // ==========================================
        // ====== 右侧：代理源与链接生成器方法 ======
        // ==========================================
        providerLabel(provider) {
            const item = this.providers.find(entry => entry.value === provider)
            return item ? item.label : provider || '-'
        },
        getRegionLabel(areaValue) {
            if (!areaValue || areaValue === 'all' || areaValue === '全国') return '全国'
            const item = (this.regions || []).find(r => r.value === areaValue || r.label === areaValue)
            return item ? item.label : areaValue
        },
        loadMetadata() {
            return proxySourceService.metadata().then(res => {
                this.providers = res.data?.providers || []
            })
        },
        loadRegions() {
            return proxySourceService.regions().then(res => {
                this.regions = res.data || []
            })
        },
        loadSources() {
            this.loadingSources = true
            return proxySourceService.list({}, { sortOrder: 1, createdTime: -1 }).then(res => {
                const list = (res.data || []).map(item => ({
                    ...item,
                    sortOrder: item.sortOrder != null ? Number(item.sortOrder) : 0
                }))
                list.sort((a, b) => {
                    if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder
                    const timeA = new Date(a.createdTime || 0).getTime()
                    const timeB = new Date(b.createdTime || 0).getTime()
                    return timeB - timeA
                })
                this.sources = list
                if (this.sources.length) {
                    this.loadAllBalances()
                }
            }).finally(() => {
                this.loadingSources = false
            })
        },
        loadAllBalances() {
            if (!this.sources.length) return Promise.resolve()
            this.loadingBalances = true
            const ids = this.sources.map(s => s._id)
            ids.forEach(id => {
                this.$set(this.balanceLoadingMap, id, true)
            })
            return proxySourceService.balances(ids).then(res => {
                const data = res.data || {}
                Object.keys(data).forEach(id => {
                    this.$set(this.balanceMap, id, data[id])
                })
            }).catch(err => {
                this.$message.error('余量查询失败: ' + (err.message || '网络错误'))
            }).finally(() => {
                ids.forEach(id => {
                    this.$set(this.balanceLoadingMap, id, false)
                })
                this.loadingBalances = false
            })
        },
        refreshSingleBalance(id) {
            if (!id) return Promise.resolve()
            this.$set(this.balanceLoadingMap, id, true)
            return proxySourceService.balance(id).then(res => {
                const data = res.data || { success: res.success, message: res.message }
                this.$set(this.balanceMap, id, data)
                if (data.success) {
                    this.$message.success('余量已更新')
                } else {
                    this.$message.warning(data.message || '余量获取异常')
                }
            }).catch(err => {
                this.$set(this.balanceMap, id, { success: false, message: err.message || '查询失败' })
                this.$message.error(err.message || '余量查询失败')
            }).finally(() => {
                this.$set(this.balanceLoadingMap, id, false)
            })
        },
        getBalanceTagType(info) {
            if (!info || !info.success) return 'info'
            if (typeof info.balance === 'number') {
                if (info.balance <= 0) return 'danger'
                if (info.balance < 50) return 'warning'
            }
            return 'success'
        },
        handleSourceChange(sourceId) {
            const source = this.sources.find(item => item._id === sourceId)
            if (!source) return
            const defaults = source.defaultParams || {}
            const defaultArea = Array.isArray(defaults.area) ? defaults.area[0] : defaults.area
            this.generateForm.area = (source.provider !== 'duomi' && defaultArea && defaultArea !== 'all' && defaultArea !== '全国') ? defaultArea : ''
            this.generateForm.num = Number(defaults.num || 1)
            this.generateForm.protocol = defaults.protocol || 'http'
            this.generateForm.resultType = defaults.resultType || 'text'
            this.generateForm.split = defaults.split || 1
            this.generateForm.filter = defaults.filter === 0 ? 0 : 1
            this.generateForm.autoWhite = source.providerConfig?.autoWhite !== undefined ? source.providerConfig.autoWhite : 1
            this.generatedLink = ''
            this.generatedSummary = null
            this.fetchResult = null
        },
        resetGenerateForm() {
            const sourceId = this.generateForm.sourceId
            this.generateForm = { ...DEFAULT_GENERATE_FORM, sourceId }
            if (sourceId) this.handleSourceChange(sourceId)
            this.generatedLink = ''
            this.generatedSummary = null
            this.fetchResult = null
        },
        generateLink() {
            if (!this.generateForm.sourceId) {
                this.$message.warning('请先选择代理源')
                return
            }
            this.generating = true
            const area = this.generateForm.area ? [this.generateForm.area] : ['all']
            const options = {
                area,
                num: this.generateForm.num,
                protocol: this.generateForm.protocol,
                resultType: this.generateForm.resultType,
                split: this.generateForm.split,
                filter: this.generateForm.filter,
                autoWhite: this.generateForm.autoWhite
            }
            proxySourceService.generateLink(this.generateForm.sourceId, options).then(res => {
                this.generatedLink = res.data.url
                this.generatedSummary = res.data
                this.fetchResult = null
                this.$message.success('提取链接已生成')
            }).finally(() => {
                this.generating = false
            })
        },
        testExtractFetch() {
            if (!this.generateForm.sourceId) return
            this.testingFetch = true
            const area = this.generateForm.area ? [this.generateForm.area] : ['all']
            const options = {
                area,
                num: 1,
                protocol: this.generateForm.protocol,
                resultType: this.generateForm.resultType,
                split: this.generateForm.split,
                filter: this.generateForm.filter,
                autoWhite: this.generateForm.autoWhite
            }
            proxySourceService.testFetch(this.generateForm.sourceId, options).then(res => {
                this.fetchResult = res.data || { success: res.success, message: res.message }
                if (this.fetchResult.success) {
                    this.$message.success('测试成功，已正常提取到代理 IP')
                } else {
                    this.$message.warning(this.fetchResult.message || '测试异常')
                }
            }).catch(err => {
                this.fetchResult = {
                    success: false,
                    message: err.message || '请求失败'
                }
            }).finally(() => {
                this.testingFetch = false
            })
        },
        copyLink() {
            if (!this.generatedLink) return
            this.copyText(this.generatedLink, '提取链接已复制到剪贴板')
        },
        copyText(text, successMsg = '已复制') {
            if (!text) return
            this.$copyText(String(text)).then(() => {
                this.$message.success(successMsg)
            })
        },
        openLinkInNewTab() {
            if (this.generatedLink) {
                window.open(this.generatedLink, '_blank')
            }
        },
        clearGenerated() {
            this.generatedLink = ''
            this.generatedSummary = null
            this.fetchResult = null
        },

        // === 核心联动：一键存入左侧代理池 ===
        handleSaveToProxyPool() {
            if (!this.generatedLink) {
                this.$message.warning('请先生成提取链接')
                return
            }
            const areaLabel = this.getRegionLabel(this.generateForm.area)
            const sourceName = this.selectedSource ? this.selectedSource.name : ''
            const remark = sourceName ? `[${sourceName}] ${areaLabel}` : areaLabel

            this.$confirm(`是否将此链接存入生效代理池？<br><b>区域：</b>${areaLabel}<br><b>备注：</b>${remark}`, '存入代理池', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定存入',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.savingToProxy = true
                const payload = {
                    area: areaLabel,
                    url: this.generatedLink,
                    remark: remark
                }
                return proxyService.save(payload).then(res => {
                    this.$message.success(res.message || '已成功存入生效代理池')
                    this.fetchTableData()
                })
            }).catch(() => {}).finally(() => {
                this.savingToProxy = false
            })
        },

        // === 代理源管理 ===
        toggleSourceStatus(row) {
            proxySourceService.updateById(row._id, { enabled: row.enabled }).then(() => {
                this.$message.success(`代理源“${row.name}”已${row.enabled ? '启用' : '停用'}`)
            }).catch(() => {
                row.enabled = !row.enabled
            })
        },
        openCreateSource() {
            this.sourceFormModel = null
            this.sourceDialogVisible = true
        },
        openEditSource(row) {
            this.sourceFormModel = JSON.parse(JSON.stringify(row))
            this.sourceDialogVisible = true
        },
        handleSourceCellDbClick({ row, column }) {
            const { title, type } = column
            if (title === '操作' || title === '状态' || type === 'checkbox') {
                return
            }
            this.openEditSource(row)
        },
        handleSourceSaved() {
            this.sourceDialogVisible = false
            this.loadSources()
        },
        deleteSource(row) {
            this.$confirm(`确定删除代理源“${row.name}”吗？`, '删除提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                return proxySourceService.deleteById(row._id)
            }).then(() => {
                this.$message.success('删除成功')
                this.loadSources()
            }).catch(() => {})
        },
        updateSelectedSources() {
            this.selectedSources = this.$refs.xSourceTable.getCheckboxRecords() || []
        },
        deleteSelectedSources() {
            const ids = this.selectedSources.map(item => item._id)
            this.$confirm(`确定删除选中的 ${ids.length} 个代理源吗？`, '批量删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => proxySourceService.deleteByIds(ids)).then(() => {
                this.$message.success('删除成功')
                this.selectedSources = []
                this.loadSources()
            }).catch(() => {})
        }
    },
    created() {
        this.fetchTableData()
        this.loadMetadata()
        this.loadSources()
        this.loadRegions()
    }
}
</script>

<style lang="scss" scoped>
.full-height {
    height: 100%;
}

.proxy-page {
    box-sizing: border-box;
    overflow: hidden;
}

.full-height-row {
    height: 100%;
}

.column-box {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.right-box {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.full-card {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.right-generator-card {
    flex-shrink: 0;
}

.right-sources-card {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.card-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.card-header-title {
    font-weight: 600;
    font-size: 14px;
    color: #303133;
    display: flex;
    align-items: center;
}

.card-header-extra {
    font-size: 12px;
    color: #909399;
}

.provider-sub-text {
    margin-left: 4px;
    color: #606266;
}

/* 左侧样式 */
.left-top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    flex-wrap: wrap;
    gap: 8px;
}

.query-form ::v-deep .el-form-item {
    margin-bottom: 0;
}

.left-action-buttons {
    display: flex;
    align-items: center;
    gap: 6px;
}

.table-container {
    flex: 1;
    min-height: 200px;
}

.sources-table-container {
    flex: 1;
    min-height: 150px;
}

.pager-container {
    margin-top: 6px;
    flex-shrink: 0;
}

/* 右侧生成器表单样式 */
.generator-inline-form {
    margin-bottom: -10px;

    ::v-deep .el-form-item {
        margin-bottom: 10px;
        margin-right: 12px;
    }
}

.source-select-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
}

.selected-balance-inline {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.balance-refresh-icon {
    cursor: pointer;
    color: #909399;
    font-size: 12px;
    transition: color 0.2s;

    &:hover {
        color: #409eff;
    }
}

.option-provider-text {
    float: right;
    color: #909399;
    font-size: 12px;
}

.empty-source-tip {
    margin-top: 4px;
    font-size: 12px;
    color: #e6a23c;
    display: flex;
    align-items: center;
    gap: 4px;
}

.result-action-bar {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #ebeef5;
}

.result-url-input ::v-deep input {
    font-family: monospace;
    font-size: 12px;
    background-color: #fafafa;
}

.test-feedback-box {
    margin-top: 8px;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
}

.test-feedback-box.is-success {
    background-color: #f0f9eb;
    border: 1px solid #c2e7b0;
    color: #67c23a;
}

.test-feedback-box.is-fail {
    background-color: #fef0f0;
    border: 1px solid #fbc4c4;
    color: #f56c6c;
}

.feedback-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.proxies-row {
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

.proxies-tag-title {
    font-weight: 600;
}

.proxy-tag {
    cursor: pointer;
    font-family: monospace;
}

/* 右侧代理源表格操作栏 */
.table-toolbar-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.toolbar-left,
.toolbar-right {
    display: flex;
    align-items: center;
    gap: 6px;
}

.balance-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.edition-mini-badge {
    margin-left: 4px;
    font-size: 11px;
    color: #e6a23c;
}

.text-muted {
    color: #909399;
}

.danger-link {
    color: #f56c6c;
}

.danger-link:hover {
    color: #f78989;
}
</style>
